import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, User } from "lucide-react";
import { motion } from "framer-motion";

const Navbar = ({ onLoginClick }) => {
  const { user, logout } = useAuth();
  const location = useLocation();

  return (
    <motion.nav
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="navbar sticky top-0 z-50 px-4 md:px-6 py-4"
    >
      <div className="w-full flex flex-col md:flex-row items-center justify-between">
        <Link to="/" className="flex items-center justify-center w-full md:w-auto gap-4">
          <img
            src="/globe.png"
            alt="TopNation Globe"
            style={{
              width: "48px",
              height: "48px",
              animation: "globePulse 2.5s ease-in-out infinite",
              filter:
                "drop-shadow(0 0 6px #FFD700) drop-shadow(0 0 14px #FFD700) drop-shadow(0 0 26px #FFD700)"
            }}
          />

          <span
            style={{
              fontFamily: "Cinzel",
              fontSize: "26px",
              color: "#FFD700",
              letterSpacing: "2px",
              fontWeight: "700"
            }}
          >
            Topnationapp
          </span>
        </Link>

        <div className="flex justify-center md:justify-end w-full md:w-auto mt-2 md:mt-0">
          {user ? (
            <div className="flex flex-row gap-2 justify-center md:justify-end">
              <Link to="/dashboard">
                <Button
                  className={
                    "w-[120px] md:w-[150px] bg-[#C9A227] text-black border border-[#C9A227] text-sm py-2 font-semibold hover:brightness-110 " +
                    (location.pathname === "/dashboard"
                      ? "shadow-[0_0_8px_rgba(201,162,39,0.8)]"
                      : "")
                  }
                >
                  <User className="w-4 h-4 mr-2" />
                  Dashboard
                </Button>
              </Link>

              <Button
                onClick={logout}
                className="w-[120px] md:w-[150px] bg-black border border-[#C9A227] text-[#C9A227] text-sm py-2 hover:bg-[#111]"
              >
                <LogOut className="w-4 h-4 mr-2" />
                Logout
              </Button>
            </div>
          ) : (
            <Button onClick={onLoginClick} className="btn-gold">
              Login / Sign Up
            </Button>
          )}
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;
